export default "__VITE_ASSET__BadZA9S4__"